import * as Sentry from '@sentry/vue'
import { watch, type App } from 'vue'
import type { Router } from 'vue-router'

import type { AppConfig } from '@/config'

/**
 * GlitchTip error tracking (MRS 8.2, 9) through the Sentry SDK. Off when the
 * DSN is empty, which is the default on a developer machine. Replay, profiling
 * and crons are not supported by GlitchTip and are never enabled here.
 */
export function installErrorTracking(app: App, router: Router, config: AppConfig): void {
  if (config.glitchtipDsn === null) {
    return
  }
  Sentry.init({
    app,
    dsn: config.glitchtipDsn,
    release: config.appVersion,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 0.1,
  })
}

/**
 * Names the signed-in user on every event by id, and by nothing else: an
 * e-mail address or a name never leaves the browser this way (MRS 9).
 */
export function trackSignedInUser(userId: () => number | null): void {
  watch(userId, (id) => Sentry.setUser(id === null ? null : { id: String(id) }), {
    immediate: true,
  })
}
